// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ProductionPlantVO')
export class ProductionPlantVO {
  @JsonProperty('id', 'Number')
  public id: number = undefined;

  @JsonProperty('plantNo', 'string')
  public plantNo: string = undefined;

  @JsonProperty('name', 'string')
  public name: string = undefined;

  @JsonProperty('countryCode', 'string')
  public countryCode: string = undefined;

}
